import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import Facebook from '@components/Svg/icons/facebook.inline.svg';
import Twitter from '@components/Svg/icons/twitter.inline.svg';
import Linkedin from '@components/Svg/icons/linkedin.inline.svg';
import Envelope from '@components/Svg/icons/envelope.inline.svg';
import Styles from './ShareAsideNew.module.scss';

// new version of PostShareAside component
const SocialMediaShare = forwardRef(({ children, className, ...props }, ref) => (
  <div ref={ref} className={Styles.container} style={{ ...props?.style }}>
    {children}
    <a
      className={Styles.socialButton}
      aria-label='share by email'
      href={`mailto:?subject=I wanted you to see this article &body=Check out this post ${props.postUrl}.`}
      title='Share by Email'>
      <Envelope />
    </a>
    <a
      className={Styles.socialButton}
      href={`https://twitter.com/intent/tweet?text=${props.postTitle}&url=${props.postUrl}`}
      target='_blank'
      aria-label='share on twitter'
      rel='noopener noreferrer'>
      <Twitter />
    </a>
    <a
      className={Styles.socialButton}
      href={`https://www.facebook.com/sharer/sharer.php?u=${props.postUrl}`}
      target='_blank'
      aria-label='share on facebook'
      rel='noopener noreferrer'>
      <Facebook />
    </a>

    <a
      className={Styles.socialButton}
      href={`https://www.linkedin.com/shareArticle?mini=true&url=${props.postUrl}&title=${props.postTitle}&source=Hire Digital`}
      target='_blank'
      aria-label='share on linkedin'
      rel='noopener noreferrer'>
      <Linkedin />
    </a>
  </div>
));

SocialMediaShare.propTypes = {
  postUrl: PropTypes.string,
  postTitle: PropTypes.string,
};

export default SocialMediaShare;
